import { render, staticRenderFns } from "./detail-mulu.vue?vue&type=template&id=a9bbd646&"
import script from "./detail-mulu.vue?vue&type=script&lang=js&"
export * from "./detail-mulu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports